<template>
  <kernwoorden />
</template>

<script>
import Kernwoorden from '../components/OpbouwPlechtigheid/Kernwoorden.vue'

export default {
  name: 'KernwoordenView',
  components: {
    Kernwoorden
  }
}
</script>
